export default [
  {
    path: '/task/detail',
    name: 'task_detail',
    meta: {
      title: ''
    },
    component: () => import('views/task/detail')
  },
  {
    path: '/task/psy_list',
    name: 'task_psy_list',
    meta: {
      title: ''
    },
    component: () => import('views/task/psy_list')
  },
  {
    path: '/task/psychology/sleep',
    name: "psychology_sleep",
    meta: {
      title: ''
    },
    component: () => import("views/task/psychology/sleep")
  },
  {
    path: '/task/psychology/emotion',
    name: "psychology_emotion",
    meta: {
      title: ''
    },
    component: () => import("views/task/psychology/emotion")
  },
  {
    path: '/task/task_all',
    name: "task_all",
    meta: {
      title: ''
    },
    component: () => import("views/task/task_all")
  },
  {
    path: '/task/task_detail',
    name: "task_nav_detail",
    meta: {
      title: ''
    },
    component: () => import("views/task/task_detail")
  }
]